module.exports = __webpack_public_path__ + "static/media/NO_CATS.8f63b49f.svg";